var Storage = /** @class */ (function () {
    function Storage(storage) {
        this._storage = storage;
    }
    Storage.prototype.getItem = function (key) {
        try {
            var storedValue = this._storage.getItem(key);
            if (storedValue === null) {
                return null;
            }
            // Try to parse JSON, if it fails, return raw string
            try {
                return JSON.parse(storedValue);
            }
            catch (_a) {
                return storedValue;
            }
        }
        catch (error) {
            console.error("Error reading \"".concat(key, "\" from storage"), error);
            return null;
        }
    };
    Storage.prototype.removeItem = function (key) {
        try {
            this._storage.removeItem(key);
        }
        catch (error) {
            console.error("Error removing \"".concat(key, "\" from storage"), error);
        }
    };
    Storage.prototype.setItem = function (key, value) {
        try {
            var isString = typeof value === "string";
            var serializedValue = isString ? value : JSON.stringify(value);
            this._storage.setItem(key, serializedValue);
        }
        catch (error) {
            console.error("Error saving \"".concat(key, "\" to storage"), error);
        }
    };
    return Storage;
}());
export { Storage };
export var SessionStorage = new Storage(sessionStorage);
export var LocalStorage = new Storage(localStorage);
